export const SECURITY_EVENTS = {
  LOGGED_IN: "LOGGED_IN",
  LOGGED_OUT: "LOGGED_OUT",
  NO_TOKEN: "NO_TOKEN",
  INVALID_TOKEN: "INVALID_TOKEN",
  TOKEN_REFRESH: "TOKEN_REFRESH",
  TOKEN_REFRESH_SUCCESS: "TOKEN_REFRESH_SUCCESS",
  TOKEN_REFRESH_WARNING: "TOKEN_REFRESH_WARNING",
  TOKEN_RENEWED: "TOKEN_RENEWED",
  SESSION_EXPIRED: "SESSION_EXPIRED"
} as const;

export const APPLICATION_EVENTS = {
    A: "A",
    B: "B",
  } as const;

export type TRACKED_EVENT_TYPES = typeof SECURITY_EVENTS;// | typeof APPLICATION_EVENTS;